import { EntityBase } from "./EntityBase";
import { Offer } from "./Offer";
import { User } from "./User";
import { Account } from "./Account";
import { ExistingContract } from "./ExistingContract";

export class BuyOffer extends Offer {
    accounts: Account[] = null!;
    specialRequest: string = null!;
    isClosed: boolean = null!;
    pendingClosedPeriod: Date = null!;

    priceForBuyer(): number {
       return this.price;
    }

    priceForSeller(): number {
       return this.price-this.fee;
    }
}
